import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export const usePageMeta = (key = null, hasDescription = true) => {
  const { t, i18n } = useTranslation();
  const titleSuffix = "Offood";
  const location = useLocation();
  const pathname = location.pathname;
  const domain = window.location.hostname.includes("dev")
    ? "https://dev.offood.ch"
    : "https://offood.ch";

  const title = key
    ? `${t(`meta.${key}.title`)} · ${titleSuffix}`
    : titleSuffix;

  const description =
    hasDescription && key ? t(`meta.${key}.description`) : null;

  const canonical = `${domain}${pathname}`;

  return (
    <Helmet>
      <html lang={i18n.language} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
};

export const usePageTitle = (titleKey) => {
  const { t } = useTranslation();
  const titleSuffix = "Offood";
  useEffect(() => {
    document.title = titleKey
      ? `${t(`meta.${titleKey}`)} · ${titleSuffix}`
      : titleSuffix;
  }, [titleKey, t]);
};
